<template>
   <v-container fluid>
      <template v-if="message">
         <v-card outlined class="px-2" :color="$globalstore.secondary_titleclass">
            <v-row no-gutters>
               <!-- <v-col cols="1" md="1" align-self="start">
               </v-col> -->
               <v-col cols="9" md="8" class="pa-2" align-self="center">
                  <v-icon class="pa-0 my-3" @click="goBack()">mdi-chevron-left </v-icon>
                  <span class="font-weight-medium">
                     {{ message.msg_sendername }}
                  </span>
               </v-col>
               <v-col cols="3" md="4" align-self="center">
                  <p class="text-right pa-0 my-3">{{ message_date }}</p>
               </v-col>
            </v-row>
         </v-card>
         <v-card outlined class="mt-1">
            <v-card-text>
               <div class="text-subtitle-1 font-weight-medium">
                  Subject
               </div>
               <span class="text-body-1">{{ message.msg_subject }}</span>
            </v-card-text>
         </v-card>
         <v-card flat class="mt-2 over-flow-y-auto pa-2">
            <editor-content :editor="editor" />
         </v-card>
      </template>
   </v-container>
</template>

<script>
   import {Editor, EditorContent} from "@tiptap/vue-2";
   import StarterKit from "@tiptap/starter-kit";

   export default {
      props: ["msg"],

      components: {EditorContent},

      data() {
         return {
            today: "",
            message: null,
            editor: null,
         };
      },

      computed: {
         message_date() {
            return this.message ? this.fmtDate(this.message.msg_date) : "";
         },
      },

      methods: {
         goBack() {
            this.$router.go(-1);
         },

         fmtDate(date) {
            const d1 = new Date(date);
            const d2 = new Date();

            let d1str = this.$globalstore.dateToISOString(d1).substr(0, 10);
            let d2str = this.$globalstore.currentDateISOString().substr(0, 10);

            if (d1str === d2str) {
               return (
                  d1
                     .getHours()
                     .toString()
                     .padStart(2, "0") +
                  ":" +
                  d1
                     .getMinutes()
                     .toString()
                     .padStart(2, "0")
               );
            } else {
               if (d1.getFullYear() === d2.getFullYear()) {
                  let month = new Intl.DateTimeFormat("en-US", {
                     month: "short",
                  }).format(d1);
                  let day = d1.getDate();
                  return month.toString() + " " + day.toString();
               } else {
                  const [year, day] = [d1.getFullYear(), d1.getDate()];
                  let month = new Intl.DateTimeFormat("en-US", {
                     month: "short",
                  }).format(d1);

                  return year.toString().substr(2) + " " + month.toString() + " " + day.toString();
               }
            }
         },
      },

      mounted() {
         this.editor = new Editor({
            editable: false,
            content: "",
            extensions: [StarterKit],
         });

         if (this.msg) {
            this.message = this.msg;
         } else if (this.$route.params) {
            this.message = this.$route.params;
         }
         this.editor.commands.setContent(this.message.msg_body);
      },
   };
</script>
